import { defineStore } from 'pinia';
import { ref } from 'vue';
import serverFetch from '@globals/ServerFetch';
import RfpsList from '@customer/rfp/RfpsList';

export const useCustomerRfpListStore = defineStore('customerRfpList', () => {
	const state = {
		rfpsList: ref(new RfpsList('Rfps')),
		contactsList: ref(new RfpsList('Contacts')),
		displayApContactsIncentiveBox: ref(false),
		displayApRfpListIncentiveBox: ref(false),
		isFromListBox: ref(false),
		fromListType: ref(''),
		selectedRfpId: ref(-1),
		selectedRfp: ref(null),
		selectedListType: ref<'Rfps' | 'Contacts' | ''>(''),
		selectedFilterQuery: ref({}),
		photoPreview: ref(''),
		photoPreviewFilename: ref(''),
		isAutoUncover: ref(false),
		toggleChat: ref(false),
	};

	const actions = {
		async shouldDisplayApContactsIncentiveBox() {
			const response = await serverFetch('/customer/should-display-ap-contacts-stimulation-box.do', {}, 'GET', false, false);
			state.displayApRfpListIncentiveBox.value = response.shouldDisplayApStimulationBox;
		},
		async shouldDisplayApRfpListIncentiveBox() {
			const response = await serverFetch('/customer/should-display-ap-rfp-list-stimulation-box.do', {}, 'GET', false, false);
			state.displayApRfpListIncentiveBox.value = response.shouldDisplayApStimulationBox;
		},
		getList(listType: 'Rfps' | 'Contacts') {
			const listName = listType ? listType.toLowerCase() : 'rfps';
			return state[`${listName}List` as 'rfpsList' | 'contactsList'].value;
		},
		updateFlags(flags: string[]) {
			if (flags && flags.indexOf('show_best_rfps') > -1) {
				actions.getList('Rfps').ShowBestRfps = true;
			}
		},
	};

	const getters = {};

	return { ...state, ...actions, ...getters };
});
